import { BRAND_COLORS } from '~/components/brand';

const RING_MS = 1600;

/** The DOM id of a card's frame on the board, so the chat can point at it. */
export function lensCardDomId(cardId: string): string {
  return `lens-card-${cardId}`;
}

/**
 * Scrolls the board to a card and rings it briefly in Ocean Teal. The ring is a short Web
 * Animation, so reduced-motion readers get the scroll and a static ring that fades without
 * movement.
 */
export function showCardOnBoard(cardId: string): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  const element = document.getElementById(lensCardDomId(cardId));
  if (!element) {
    return false;
  }
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  element.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  element.animate(
    [
      { outline: `2px solid ${BRAND_COLORS.oceanTeal}`, outlineOffset: '2px' },
      { outline: `2px solid ${BRAND_COLORS.oceanTeal}`, outlineOffset: '2px', offset: 0.7 },
      { outline: '2px solid transparent', outlineOffset: '2px' },
    ],
    { duration: RING_MS, easing: 'ease-out' },
  );
  return true;
}
